import { APP_PREFIX_PATH } from '@constants/common';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

const usePrefixedNavigate = () => {
    const navigate = useNavigate();

    const prefixedNavigate = (to: To | number, options?: NavigateOptions) => {
        // If 'to' is a string and doesn't already contain the APP_PREFIX_PATH, prepend it
        if (
            (typeof to === 'string' && !to.startsWith(APP_PREFIX_PATH)) ||
            (typeof to === 'object' &&
                'pathname' in to &&
                typeof to.pathname === 'string' &&
                !to.pathname.startsWith(APP_PREFIX_PATH))
        ) {
            return navigate(
                typeof to === 'string' ? APP_PREFIX_PATH + to : { ...to, pathname: APP_PREFIX_PATH + to.pathname },
                options
            );
        }
        // If to is a number handle the standard navigate method's overload
        if (typeof to === 'number') {
            return navigate(to);
        }
        // Otherwise, just use the standard navigate with a path
        return navigate(to, options);
    };

    return prefixedNavigate;
};

export { usePrefixedNavigate };
